import { render, staticRenderFns } from "./PostDate.vue?vue&type=template&id=7c47b24b&scoped=true&"
import script from "./PostDate.vue?vue&type=script&lang=js&"
export * from "./PostDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47b24b",
  null
  
)

export default component.exports